(() => {
  const guideOnlyModels = [
    ['dell-pro-13-plus-pb13250-layout.png', 'Dell Pro 13 Plus', 'PB13250'],
    ['dell-pro-14-plus-pb14250-p199g002-layout.png', 'Dell Pro 14 Plus', 'PB14250'],
    ['dell-pro-14-pc14250-p193g002-layout.png', 'Dell Pro 14', 'PC14250'],
    ['dell-pro-16-pc16255-layout.png', 'Dell Pro 16', 'PC16255']
  ];

  const initialize = (scope) => {
    scope.querySelectorAll('[data-dwan-model-guide]').forEach((guide) => {
      if (guide.dataset.guideInitialized) return;
      guide.dataset.guideInitialized = 'true';

      const select = guide.querySelector('[data-guide-brand-select]');
      const selector = guide.querySelector('.dwan-model-guide__mobile-selector');
      if (select && selector) {
        selector.hidden = false;
        guide.classList.add('dwan-model-guide--enhanced');
        select.addEventListener('change', () => {
          const destination = new URL(select.value, window.location.origin);
          if (destination.origin !== window.location.origin) return;
          const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (preview) destination.searchParams.set('preview_theme_id', preview);
          window.location.assign(destination.href);
        });
      }

      if (guide.dataset.guideBrand === 'lenovo') {
        const codeLabel = guide.querySelector('[data-guide-model-code-label]')?.textContent.trim();
        guide.querySelectorAll('.dt-lenovo-guide figure[data-model-reference]').forEach((card) => {
          const caption = card.querySelector('figcaption');
          const image = card.querySelector('img');
          const code = image?.alt.match(/\(([A-Z0-9 /-]+)\) reference illustration$/)?.[1];
          if (!codeLabel || !code || !caption || caption.querySelector('p')) return;
          const modelCode = document.createElement('p');
          modelCode.className = 'dwan-model-guide__model-code';
          modelCode.textContent = `${codeLabel} ${code}`;
          caption.append(modelCode);
          card.dataset.dwanModelCode = 'true';
        });
      }

      if (guide.dataset.guideBrand !== 'dell') return;
      const noticeText = guide.querySelector('[data-guide-only-label]')?.textContent.trim();
      if (!noticeText) return;

      guideOnlyModels.forEach(([filename, title, code]) => {
        const image = guide.querySelector(`.dt-dell-guide img[src*="/${filename}"]`);
        const card = image?.closest('figure');
        const caption = card?.querySelector('figcaption');
        if (!card || !caption || card.dataset.dwanGuideOnly) return;
        if (caption.querySelector('h3')?.textContent.trim() !== title) return;
        if (!caption.textContent.includes(code)) return;
        const notice = document.createElement('p');
        notice.className = 'dwan-model-guide__guide-only';
        notice.textContent = noticeText;
        caption.append(notice);
        card.dataset.dwanGuideOnly = 'true';
      });
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
